import { combineEpics } from 'redux-observable';
import fetchSports from './fetchSports';

export const sportsEpic = combineEpics(fetchSports);
